export default __webpack_public_path__ + "static/media/ltr_testimonials.3e0e7067.png";